module.exports = __webpack_public_path__ + "static/inno3-25288335939807ceb20aa260b26b551d.jpg";